export const FollowText = 'Follow';
export const FollowingText = 'Following';

export const UnfollowedText = 'Unfollowed';
